<table class="syn-inventory-list__table">
    <tbody>
    <tr *ngFor="let line of filler(matrix[1])">
        <td *ngFor="let column of filler(matrix[0])" [ngStyle]="{width: (100 / matrix[0]) + '%'}" [ngClass]="{
            'syn-inventory-list__cell--active': isActive(line, column),
            'syn-inventory-list__cell--highlighted': isHighlighted(line, column)
        }">

            <span class="syn-flexrow syn-flexrow--fluid">
                <span *ngIf="checkedMonths" class="syn-flexrow__cell--minwidth">
                    <syn-boolean-ico [check]="checkedMonths[line * matrix[0] + column]"></syn-boolean-ico>
                </span>
                <span class="syn-inventory-list__label">
                    <span *ngIf="labelType == 'alias'">{{ monthsAlias[getIndex(line, column) % count()] }}</span>
                    <span *ngIf="labelType == 'name'">{{ monthsName[getIndex(line, column) % count()] }}</span>
                </span>
            </span>

        </td>
    </tr>
    </tbody>
</table>
